import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class AbstractType extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;
}
